import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import InputLabel from "@material-ui/core/InputLabel";
import React from "react";
import { FieldRowFC } from "./types";

const FieldRow: FieldRowFC = ({
  label,
  required = false,
  children,
  appendLabel,
}) => {
  return (
    <>
      <Grid
        item
        xs={12}
        sm={5}
        sx={{
          justifyContent: "flex-end",
          textAlign: {
            sm: "right",
          },
        }}
      >
        <Box
          sx={{
            alignSelf: "center",
            pb: { md: 0, sx: 1 },
            pr: { sm: 3 },
            pt: "16px",
          }}
        >
          <Grid container alignItems={"end"}>
            <Grid item xs sm={12}>
              {label ? (
                <InputLabel required={required}>{label}</InputLabel>
              ) : null}
            </Grid>
            {appendLabel ? (
              <Grid item sm={12} sx={{ mt: 1 }}>
                {appendLabel}
              </Grid>
            ) : null}
          </Grid>
        </Box>
      </Grid>
      <Grid item xs={12} sm={7} sx={{ mb: "24px" }}>
        {children}
      </Grid>
    </>
  );
};
export default FieldRow;
